module.exports = __webpack_public_path__ + "img/list_Character_sq_10.329f30df.jpeg";